module.exports = __webpack_public_path__ + "7ac7d1c95113e30046c9ea00abfa1e35.svg";